import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthService } from '@vinnova/auth';
import { switchMap, take } from 'rxjs';
import { environment } from '../environment';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  lastLog: string;

  private authService = inject(AuthService);
  private httpClient = inject(HttpClient);
  private env = inject(environment);
  private logServiceUrl = this.env.logServiceApiUrl + '/loggafrontend';

  logMessage(level: number, message: string, stack?: string) {
    if (this.lastLog && this.lastLog === message) {
      return;
    }
    this.lastLog = message;

    this.authService
      .getPersonDetails()
      .pipe(
        take(1),
        switchMap((details) => {
          const payload = {
            level,
            message,
            stack: stack ?? '',
            user: details.email,
            userAgent: navigator.userAgent,
            url: location.href,
          };
          return this.httpClient
            .post<void>(this.logServiceUrl, payload)
            .pipe(take(1));
        }),
      )
      .subscribe();
  }
}
